import React from 'react';
export function Guarantee() {
  return <div className="bg-[#0c0c0c] py-16 px-6" data-id="element-176">
      <div className="max-w-[960px] mx-auto" data-id="element-177">
        <div className="bg-brand-green/5 border-2 border-brand-green/20 rounded-2xl py-11 px-9 text-center max-w-[600px] mx-auto" data-id="element-178">
          <div className="w-20 h-20 rounded-full bg-brand-green text-white font-display flex flex-col items-center justify-center mx-auto mb-5 leading-none" data-id="element-179">
            <span className="text-[28px] font-bold" data-id="element-180">7</span>
            <span className="text-[11px] font-semibold tracking-[1px]" data-id="element-181">
              DÍAS
            </span>
          </div>

          <h2 className="font-display text-[26px] text-white mb-3.5 uppercase" data-id="element-182">
            Garantía Incondicional de 7 Días
          </h2>

          <div className="flex flex-col gap-2 mb-5" data-id="element-183">
            <div className="flex items-center justify-center gap-2 text-[14px] text-white/80" data-id="element-184">
              <span className="text-brand-green text-[16px]" data-id="element-185">✦</span> Devolución
              del 100%
            </div>
            <div className="flex items-center justify-center gap-2 text-[14px] text-white/80" data-id="element-186">
              <span className="text-brand-green text-[16px]" data-id="element-187">✦</span> Sin
              formularios
            </div>
            <div className="flex items-center justify-center gap-2 text-[14px] text-white/80" data-id="element-188">
              <span className="text-brand-green text-[16px]" data-id="element-189">✦</span> Sin drama
            </div>
          </div>

          <p className="text-[13px] text-brand-muted italic leading-[1.7]" data-id="element-190">
            "Sé que ya intentaste de todo. Sé que tenés miedo de decepcionarte
            de nuevo. Por eso el riesgo es nuestro — no tuyo. Aplicás el método
            7 días y si no ves diferencia en la balanza, en la ropa o en tu
            energía, te devolvemos el 100% de tu plata. Sin preguntas. Nosotras
            asumimos el riesgo. Tasa de devoluciones: menos del 1%."
          </p>
        </div>
      </div>
    </div>;
}